/**
 * @param {Event} $event
 * @param {Element} element
 * @param {Element} editorRoot
 * @param {Object} offset
 * @param {Function} onDrop
 */
export const initDrag = ($event, element, editorRoot, offset, onDrop) => {
  const dropEventType = $event.type === 'mousedown' ? 'mouseup' : 'click';

  const drop = function (event) {
    if (editorRoot) {
      const objectElement = document.querySelector('.object-dragable');
      objectElement.remove();
      objectElement.classList.remove('object-dragable');
      if (event.target.classList.contains('pc') || event.target.closest('.pc')) {
        objectElement.style.top = ((event.offsetY || event.layerY) - offset.y) + 'px';
        objectElement.style.left = ((event.offsetX || event.layerX) - offset.x) + 'px';
        event.target.appendChild(objectElement);
      } else {
        const page = event.target.querySelector('.pc');
        objectElement.style.top = ((event.offsetY || event.layerY) - offset.y) + 'px';
        objectElement.style.left = event.offsetX - page.offsetLeft - offset.x + 'px';
        page.appendChild(objectElement);
      }
      editorRoot.removeEventListener('mousemove', drag, false);
      editorRoot.removeEventListener(dropEventType, drop, false);
      onDrop();
    }
  };

  const drag = function (event) {
    const objectElement = document.querySelector('.object-dragable');
    if (objectElement) {
      objectElement.style.top = ((event.pageY || event.clientY) - offset.y) + 'px';
      objectElement.style.left = ((event.pageX || event.clientX) - offset.x) + 'px';
    }
  };

  if (element.classList.contains('t')) {
    element.classList.add('obj-moved');
    element.style.bottom = 'unset';
    element.setAttribute('moved', true);
  }

  element.style.position = 'absolute';
  element.classList.add('object-dragable');
  element.style.top = (($event.pageY || $event.clientY) - offset.y) + 'px';
  element.style.left = (($event.pageX || $event.clientX) - offset.x) + 'px';

  editorRoot.appendChild(element);
  editorRoot.addEventListener('mousemove', drag, false);
  editorRoot.addEventListener(dropEventType, drop, false);
};

/**
 * @param {Event} $event
 * @param {Element} element
 * @param {Element} editorRoot
 * @param {Function} onStop
 */
export const initResize = function ($event, element, editorRoot, onStop) {
  const parent = element.parentNode;
  const startX = $event.clientX;
  const startY = $event.clientY;
  const computedStyles = window.getComputedStyle(parent);
  const startWidth = parseInt(computedStyles.width, 10);
  const startHeight = parseInt(computedStyles.height, 10);

  element.style.height = '100%';
  element.style.width = '100%';

  editorRoot.addEventListener('mousemove', drag, false);
  editorRoot.addEventListener('mouseup', stopDrag, false);

  function drag(event) {
    parent.style.width = (startWidth + event.clientX - startX) + 'px';
    parent.style.height = (startHeight + event.clientY - startY) + 'px';
  }

  function stopDrag() {
    editorRoot.removeEventListener('mousemove', drag, false);
    editorRoot.removeEventListener('mouseup', stopDrag, false);
    onStop();
  }
};

/**
 * @param {Event} $event
 * @param {Function} onDone
 */
export const initTextEditor = function ($event, onDone) {
  const element = $event.target.closest('.obj') || $event.target.closest('.t');
  const inputElement = document.createElement('div');
  inputElement.className = 'obj-input';
  const spans = element.querySelectorAll('span');
  let largest = {};
  spans.forEach((span) => {
    const symbols = span.innerText.replace(/\s/g, '').length;
    if (span.innerText && span.innerText.replace(/\s/g, '').length) {
      if (!largest.symbols || symbols >= largest.symbols) {
        largest = {
          span,
          symbols,
        };
      }
    }
  });

  if (largest.span) {
    const computed = window.getComputedStyle(largest.span);
    element.style.fontFamily = computed.fontFamily;
    element.style.lineHeight = computed.lineHeight;
    element.style.fontStyle = computed.fontStyle;
    element.style.fontWeight = computed.fontWeight;
  }

  const text = element.innerText.replace(/"/g, "&quot;");
  inputElement.innerHTML = `<textarea cols=${text.length} rows="2">${text}</textarea>`;

  element.appendChild(inputElement);
  element.classList.add("obj-input-active");
  //45px - увеличение ширини textarea при редактировании
  inputElement.style.width = inputElement.offsetWidth + 45 + "px";

  window.setTimeout(function () {
    const input = inputElement.querySelector("textarea");
    input.style.fontSize = element.style.fontSize;
    input.style.color = element.style.color;
    input.style.fontWeight = element.style.fontWeight;
    input.style.fontFamily = element.style.fontFamily;
    input.style.textAlign = element.style.textAlign;
    input.focus();

    input.onkeyup = (key) => {
      if (key.code === "Enter" && !key.shiftKey) {
        const start = input.selectionStart;
        const objText = document.querySelector(".obj-text");
        input.value = input.value.slice(0, start - 1) + input.value.slice(start);
        if (objText)
          input.value = input.value.replaceAll('\n', '</br>')
        input.onblur = null;
        onDone(input);
      }
    };

    input.onblur = () => {
      const start = input.selectionStart;
      const objText = document.querySelector(".obj-text");
      input.value = input.value.slice(0, start) + input.value.slice(start);
      if (objText)
        input.value = input.value.replaceAll('\n', '</br>')
      onDone(input);
    };
  }, 100);
};

export const initMoveByKeys = (event, scaleFactor, keyEventCount) => {
  let step = 1;

  if (keyEventCount >= 60) {
    step = 7;
  } else if (keyEventCount >= 30) {
    step = 3;
  }

  const isMove = !document.querySelector(".obj-input") && document.querySelector(".color-picker__list-hide");

  if ([37, 38, 39, 40].includes(event.keyCode) && isMove) {
    event.preventDefault();

    const element = document.querySelector('.obj-controls').parentNode;
    const pageContent = element.closest('.pc');

    const { top, left } = getChildPosition(element, pageContent, scaleFactor);

    pageContent.append(element);

    if (!document.querySelectorAll(".obj-text, .obj-form")) {
      element.style.top = `${top}px`;
      element.style.left = `${left}px`;
    }

    switch (event.keyCode) {
      case 37:
        element.style.left = `${parseInt(getCSSvalue(element, 'left'), 10) - step}px`;
        break;
      case 38:
        element.style.top = `${parseInt(getCSSvalue(element, 'top'), 10) - step}px`;
        break;
      case 39:
        element.style.left = `${parseInt(getCSSvalue(element, 'left'), 10) + step}px`;
        break;
      case 40:
        element.style.top = `${parseInt(getCSSvalue(element, 'top'), 10) + step}px`;
        break;
    }
  }
};

const getCSSvalue = (element, property) => window.getComputedStyle(element).getPropertyValue(property);

const getChildPosition = (child, parent, scaleFactor) => {
  const parentRect = parent.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();

  const top = Math.round(childRect.top - parentRect.top - child.offsetHeight + (child.offsetHeight * scaleFactor));
  const left = Math.round(childRect.left - parentRect.left);

  return { top, left };
};
